import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';
import { Payment } from './payment.model';
import { Invoice, InvoiceService } from '../invoice';
import { PaymentService } from './payment.service';
import { PaymentItem } from '../payment-item/payment-item.model';
import { PaymentItemService } from '../payment-item/payment-item.service';
import { PaymentUtilService } from './payment.util.service';
import { School, SchoolService } from '../school';

import { Principal, CRUD_ACTIONS } from '../../shared';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BlobUtilities } from '../../shared/blob/blob-utils';


@Component({
    selector: 'jhi-payment-detail',
    templateUrl: './payment-detail.component.html'
})
export class PaymentDetailComponent implements OnInit, OnDestroy {

    currentAccount: any;
    payment: Payment;
    private currentUserIsStudent: boolean;
    private currentSchool: School;

    paymentItems: PaymentItem[];
    invoices: Invoice[];
    paymentItemsTotalAmount = 0;
    eventSubscriber: Subscription;

    private subscription: any;
    private paymentSubscription: any;
    private invoiceSubscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private paymentService: PaymentService,
        private paymentItemService: PaymentItemService,
        private paymentUtilService: PaymentUtilService,
        private schoolService: SchoolService,
        private invoiceService: InvoiceService,
        private principal: Principal,
        private route: ActivatedRoute,
        private eventManager: EventManager,
    ) {
        this.jhiLanguageService.setLocations(['payment', 'paymentType', 'paymentItem', 'invoice', 'invoiceStatus']);
    }

    ngOnInit() {
         this.principal
                .hasOnlyAuthority('ROLE_USER')
                .then((response) => {
                    this.currentUserIsStudent = response;
                });

        this.principal.identity()
        .then((account) => {
            this.currentAccount = account;
        })
        .then(() => {
            this.eventSubscriber = this.eventManager
            .subscribe('paymentItemListModification', (response) => {
                this.handlePaymentItemListChanged(response.content);
            });

            this.paymentSubscription = this.eventManager
            .subscribe('paymentListModification', (response) => {
                this.payment = response['content']['content'];
            });

            this.invoiceSubscription = this.eventManager
            .subscribe('invoiceListModification', (response) => {
                this.handleInvoiceListChanged(response.content);
            });

            this.subscription = this.route.params.subscribe(params => {
                this.load(params['id']);
            });
        });

        this.schoolService.findCurrent()
            .subscribe(school => {
                    this.currentSchool = school;
                });
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
        this.subscription.unsubscribe();
        this.paymentSubscription.unsubscribe();
        this.invoiceSubscription.unsubscribe();
    }

    load(id) {
        this.paymentService.find(id).subscribe(payment => {
            this.payment = payment;
            this.loadPaymentItems(this.payment.id);
            this.loadInvoices(this.payment.id);
        });
    }

    previousState() {
        window.history.back();
    }

    private loadPaymentItems(id: number) {
        this.paymentItemService.search({
            query: 'payment.id:' + id,
            size: this.paymentUtilService.MAX_PAYMENT_ITEMS,
            sort: ['beneficiary.id', 'desc']
        }).subscribe(
            (res: HttpResponse<PaymentItem[]>) => this.onPaymentItemSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );

    }

    private loadInvoices(id: number) {
        this.invoiceService.search({
            query: 'payment.id:' + id,
            size: this.paymentUtilService.MAX_PAYMENT_ITEMS,
            sort: ['id', 'desc']
        }).subscribe(
            (res: HttpResponse<PaymentItem[]>) => this.onInvoiceSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    disableGenerateInvoiceButton() {
        const reversedStatus: any = 'REVERSED';
        const noPaymentItems = !this.paymentItems || this.paymentItems.length === 0;
        const hasNonReversedInvoices = this.invoices && this.invoices.some(inv => inv.status !== reversedStatus);

        return noPaymentItems || hasNonReversedInvoices;
    }

    disablePaymentDetailActions(): boolean {
        const finalizedStatus: any = 'FINALIZED';
        return this.invoices && this.invoices.some(inv => inv.status === finalizedStatus) ? true : false;
    }

    openPdf(invoice: Invoice): void {
        this.invoiceService.generatePdf(invoice).subscribe(
            (pdfBlob: Blob) => {
                BlobUtilities.openBlobInAnotherTab(pdfBlob);
            },
            (error: HttpErrorResponse) => {
                this.onError(error);
            }
        );
    }

    disableRequestInvoiceButton(): boolean {
        return !this.currentSchool.invoiceGenerationByStudentEnabled || !this.currentUserIsStudent;
    }


    private onPaymentItemSuccess(data, headers) {
        this.paymentItems = data;
        this.calculateTotalAmount();
    }

    private onInvoiceSuccess(data, headers) {
        this.invoices = data;
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    private calculateTotalAmount() {
        this.paymentItemsTotalAmount = this.paymentUtilService.calculateTotalAmount(this.paymentItems);
    }

    private handlePaymentItemListChanged(result: { action: string, content: any }) {
        switch (result.action) {
            case CRUD_ACTIONS.CREATE:
                this.paymentItems.push(result.content);
                this.calculateTotalAmount();
                break;
            case CRUD_ACTIONS.UPDATE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    if (this.paymentItems[index].id === result.content.id) {
                        this.paymentItems[index] = result.content;
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
            case CRUD_ACTIONS.DELETE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    if (this.paymentItems[index].id === result.content.id) {
                        this.paymentItems.splice(index, 1);
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
        }
    }

    private handleInvoiceListChanged(result: { action: string, content: any }) {
        switch (result.action) {
            case CRUD_ACTIONS.CREATE:
                this.invoices.push(result.content);
                break;
            case CRUD_ACTIONS.UPDATE:
                for (let index = 0; index <= this.invoices.length - 1; index++) {
                    if (this.invoices[index].id === result.content.id) {
                        this.invoices[index] = result.content;
                        break;
                    }
                }
                break;
            case CRUD_ACTIONS.DELETE:
                for (let index = 0; index <= this.invoices.length - 1; index++) {
                    if (this.invoices[index].id === result.content.id) {
                        this.invoices.splice(index, 1);
                        break;
                    }
                }
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment-detail.component.ts